<c-toaster
  placement="top-end"
  position="fixed"
  class="notification-wrapper"
></c-toaster>
